<template>
  <div class="admin-login">
    <div class="admin-login__card">
      <h2 class="admin-login__title">Painel Administrativo</h2>
      <form class="admin-login__form" @submit.prevent="handleLogin">
        <div class="admin-login__field">
          <label for="email">E-mail</label>
          <input
            id="email"
            v-model="email"
            type="email"
            placeholder="seu@email.com"
            required
            autocomplete="username"
          />
        </div>
        <div class="admin-login__field">
          <label for="password">Senha</label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="Senha"
            required
            autocomplete="current-password"
          />
        </div>
        <p v-if="errorMsg" class="admin-login__error">{{ errorMsg }}</p>
        <button type="submit" class="admin-login__btn" :disabled="isLoading">
          {{ isLoading ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '@/api';

export default {
  name: 'AdminLogin',
  setup() {
    const router = useRouter();
    const email = ref('');
    const password = ref('');
    const errorMsg = ref('');
    const isLoading = ref(false);

    const handleLogin = async () => {
      errorMsg.value = '';
      isLoading.value = true;
      try {
        const response = await api.login(email.value, password.value);
        const { token } = response.data;
        sessionStorage.setItem('admin_token', token);
        router.push({ name: 'AdminDashboard' });
      } catch (err) {
        errorMsg.value = err.response?.data?.message || 'Credenciais inválidas.';
      } finally {
        isLoading.value = false;
      }
    };

    return { email, password, errorMsg, isLoading, handleLogin };
  },
};
</script>

<style scoped src="./style.css"></style>
